export default function About() {
  return (
    <section id="about" className="py-24 px-6 bg-amber-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-6 py-2 border border-gray-800 rounded-full text-sm uppercase tracking-wider text-gray-800 mb-8">
            Our Approach
          </span>
          <h2 className="text-4xl md:text-5xl font-serif leading-relaxed text-gray-900 mb-8">
            We celebrate <em className="text-gray-600 font-light">Nigerian design heritage</em> while embracing modern luxury. Our designs blend Afrocentric aesthetics with contemporary functionality, creating spaces that <em className="text-gray-600 font-light">honor our culture and inspire daily living</em>.
          </h2>
        </div>

        <div className="mb-12">
          <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://public.readdy.ai/ai/img_res/210e2dc82c23eb089719b49d95dd8edd.jpg"
              alt="Our design process"
              className="w-full h-full object-cover object-top"
              style={{ filter: 'contrast(1.05) saturate(0.95)' }}
            />
          </div>
        </div>

        <div className="text-center">
          <button className="px-10 py-4 bg-gray-900 text-white rounded-full text-base font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer">
            Explore Our Process
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-20">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-pencil-ruler-2-line text-5xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Thoughtful Design</h3>
            <p className="text-gray-600 leading-relaxed">
              Every element celebrates Nigerian craftsmanship—from locally sourced wood and terracotta to Afrocentric art pieces—creating harmonious spaces that reflect your unique style.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-palette-line text-5xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Afrocentric Vision</h3>
            <p className="text-gray-600 leading-relaxed">
              We transform ordinary rooms into extraordinary experiences through warm earthy palettes, rich African fabrics, and curated furnishings that honor our heritage.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-user-heart-line text-5xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Client-Centered</h3>
            <p className="text-gray-600 leading-relaxed">
              Your vision guides our process. From our Abuja-based studio, we collaborate closely to ensure every detail exceeds your expectations and celebrates your story.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}